import { LocalStorageService } from './../../core/localstorage.service';
import { Router } from '@angular/router';
import { ErrorMessageService } from './../../utility/error-message/error-message.service';
import { LoaderService } from './../../utility/loader/loader.service';
import { UserService } from 'src/app/services/user.service';
import { Component, Inject, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-user-dialogbox',
  templateUrl: './user-dialogbox.component.html',
  styleUrls: ['./user-dialogbox.component.scss']
})
export class UserDialogboxComponent implements OnInit {
  changePass: FormGroup;
  dialogdata: any;
  formSubmitAttempt: boolean;

  constructor(private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) data: string, private loader: LoaderService,
  private dialogRef: MatDialogRef<UserDialogboxComponent>, private userService: UserService, 
  private messageservice: ErrorMessageService, private router: Router, private localStorage: LocalStorageService) {
    this.dialogdata = data;
   }

  ngOnInit() {
    this.changePass = this.formBuilder.group({
      oldPass: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)]],
      newPass: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)]],
      confirmPass: ['', [Validators.required]],
    },
    { validator: this.checkpasswords }
    );
  }

  isFieldInvalid(field: string) {
    return (
      (this.changePass.get(field).invalid && this.changePass.get(field).touched) ||
      (this.changePass.get(field).untouched && this.formSubmitAttempt)
    );
  }

  checkpasswords(group: FormGroup) {
    let pass = group.controls.newPass.value;
    let confirmPass = group.controls.confirmPass.value;
    if(confirmPass.length >= 1){
      return pass === confirmPass ? null : { notSame: true };
    }
  }

  changePassword(){
    this.loader.show();
    if(this.changePass.controls['newPass'].value != this.changePass.controls['confirmPass'].value){
    }else{
      let param ={
        oldPassword: this.changePass.controls['oldPass'].value,
        newPassword: this.changePass.controls['newPass'].value
      }
      this.userService.changePassword(param,this.dialogdata.data.userId).subscribe(res => {
        if(res){
          this.dialogRef.close();
          this.loader.hide();
          this.messageservice.show('Success', 'User password updated successfully, please login!', 'success');
          setTimeout(()=>{
          this.localStorage.clear();
          this.router.navigate(['/login']);
          },2000);
        }
      }, (error) => {
        this.dialogRef.close();
        this.loader.hide();
        this.messageservice.show('Error', error.error, 'error');
      });
    }
  }

  deactivateAccount(){
    this.loader.show();
    this.userService.accountDeactivate(this.dialogdata.data.email).subscribe(res => {
      if(res){
        this.dialogRef.close();
        this.loader.hide();
        this.messageservice.show('Success', res.body, 'success');
      }
    }, (error) => {
      this.dialogRef.close();
      this.loader.hide();
        this.messageservice.show('Error', error.error, 'error');
    });
  }

  ngOnDestroy(){    
    this.dialogRef.close();
  }
}
